import { render } from "./password-modal.vue?vue&type=template&id=f64b8d94&scoped=true"
import script from "./password-modal.vue?vue&type=script&lang=js"
export * from "./password-modal.vue?vue&type=script&lang=js"

import "./password-modal.vue?vue&type=style&index=0&id=f64b8d94&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f64b8d94"]])

export default __exports__